exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.recipe{\r\n    max-width: 50px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/gitHub/cookbook/src/app/components/recipe-book/recipe-list/recipe-list.component.css
// module id = ../../../../../src/app/components/recipe-book/recipe-list/recipe-list.component.css
// module chunks = main